import React from 'react'
import CampActivities from '../components/CampActivities';

const Camp = () => {
  const pageName = "CAMP ACTIVITIES";
  return (
    <div>
      <CampActivities pageName={pageName}/>
    </div>
  )
}

export default Camp;
